import React from 'react';
import swal from 'sweetalert';
import { getCV } from '../Services/applicationService';
import * as utils from '../Services/utils';
import { Progress, UncontrolledTooltip } from 'reactstrap';
import * as HelpMessages from '../Services/helpMessages';
import { CreatedBy } from './enums';

export const downloadDocument = (documentUrl, documentTitle, t) => {
  if (!documentUrl) {
    swal({
      title: t('applicants.DOCUMENT_NOT_FOUND'),
      text: t('applicants.CV_NOT_FOUND_ALT'),
      icon: 'warning',
    });
    return;
  }

  getCV(documentUrl).then((response) => {
    if (response.data) {
      const urlTmp = response.config.params.url;
      const extension = urlTmp.split('.').pop();

      // const title = applicantFirstName + '_' + applicantLastName + '_CV.' + extension;
      const title = documentTitle + '.' + extension;
      const blob = new Blob([response.data]);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    } else {
      swal({
        title: t('applicants.CV_NOT_FOUND'),
        text: t('applicants.CV_NOT_FOUND_ALT'),
        icon: 'warning',
      });

      return;
    }
  });
};

export const sliderMarks = {
  0: <h4>0</h4>,
  1: <h4>1</h4>,
  2: <h4>2</h4>,
  3: <h4>3</h4>,
  4: <h4>4</h4>,
  5: <h4>5</h4>,
  6: <h4>6</h4>,
  7: <h4>7</h4>,
  8: <h4>8</h4>,
  9: <h4>9</h4>,
  10: <h4>10</h4>,
};

export const renderSuccessPercentage = (item, size) => {
  return (
    <>
      {size !== 'small' ? (
        <div className="row">
          <div className="col-9" style={{ paddingTop: '8px' }}>
            <Progress
              className="progress-xs m-0"
              value={utils.calculatePercentage(item.scoreCombined, item.maxScore)}
              color={utils.getColorForPercentage(utils.calculatePercentage(item.scoreCombined, item.maxScore))}
            />
          </div>
          <div className="col-3 text-left">{utils.calculatePercentage(item.scoreCombined, item.maxScore)}%</div>
        </div>
      ) : (
        <div>
          <div className="text-center">{utils.calculatePercentage(item.scoreCombined, item.maxScore)}%</div>
          <Progress
            className="progress-xs m-0"
            value={utils.calculatePercentage(item.scoreCombined, item.maxScore)}
            color={utils.getColorForPercentage(utils.calculatePercentage(item.scoreCombined, item.maxScore))}
          />
        </div>
      )}
    </>
  );
};

export const transformApplicationTypeName = (applicationType, t) => {
  if (applicationType === 'Normal') {
    return t('applications.NORMAL');
  } else if (applicationType === 'ForMostSuitableApplicant') {
    return t('applications.APPLICANT_AUTOMATIC');
  } else if (applicationType === 'FromCompetences') {
    return t('applications.FROM_COMPETENCES');
  } else if (applicationType === 'ForMostSuitableJobs') {
    return t('applications.JOB_AUTOMATIC');
  }

  return applicationType;
};

const getApplicationTypeInfo = (applicationType, language) => {
  if (applicationType === 'Normal') {
    return HelpMessages.getNormalApplicationsText(language);
  } else if (applicationType === 'ForMostSuitableApplicant') {
    return HelpMessages.getApplicantAutomaticApplicationsText(language);
  } else if (applicationType === 'FromCompetences') {
    return HelpMessages.getFromCompetencesApplicationsText(language);
  } else if (applicationType === 'ForMostSuitableJobs') {
    return HelpMessages.getJobAutomaticApplicationsText(language);
  }

  return applicationType;
};

export const composeApplicationType = (application, t, language) => {
  return (
    <>
      <span
        id={`infoApplication-${application.applicationId}`}
        className={utils.getBadgeColor(application.applicationType)}
      >
        {transformApplicationTypeName(application.applicationType, t)}
      </span>
      {/* <em
          id={`infoApplication-${application.applicationId}`}
          style={{ cursor: 'pointer' }}
          className="fa mr-2 fas fa-info-circle"
        > */}
      <UncontrolledTooltip
        delay={{ show: 300, hide: 0 }}
        placement="left"
        target={`infoApplication-${application.applicationId}`}
      >
        {getApplicationTypeInfo(application.applicationType, language)}
      </UncontrolledTooltip>
    </>
  );
};

export const getStarColor = (isStarred) => {
  if (isStarred === true) {
    return 'gold';
  } else {
    return 'gray';
  }
};

export const composeDisplayName = (item) => {
  const displayName = item.unique_name ? (
    !item.firstName && !item.lastName ? (
      item.unique_name
    ) : (
      item.firstName + ' ' + item.lastName
    )
  ) : !item.userFirstName && !item.userLastName ? (
    <>{item.userName}</>
  ) : (
    <>
      {item.userFirstName} {item.userLastName}
    </>
  );

  return displayName;
};

const getCreatedByLetter = (createdBy) => {
  if (createdBy === CreatedBy.Applicant || createdBy === 1) {
    return 'A';
  } else if (createdBy === CreatedBy.System || createdBy === 0) {
    return 'S';
  } else if (createdBy === CreatedBy.Recruiter || createdBy === 2) {
    return 'R';
  } else if (createdBy === CreatedBy.RecruiterFromGitHub) {
    return 'G';
  } else return '?';
};

const getCreatedByColor = (createdBy) => {
  if (createdBy === CreatedBy.Applicant || createdBy === 1) {
    return 'icon-created-by';
  } else if (createdBy === CreatedBy.System || createdBy === 0) {
    return 'icon-created-by';
  } else if (createdBy === CreatedBy.Recruiter || createdBy === 2) {
    return 'icon-created-by';
  } else if (createdBy === CreatedBy.RecruiterFromGitHub) {
    return 'icon-created-by icon-created-by-github';
  } else return 'icon-created-by';
};

export const getCreatedByMessage = (createdBy, t) => {
  if (createdBy === CreatedBy.Applicant || createdBy === 1) {
    return t('competences.CREATED_BY_APPLICANT');
  } else if (createdBy === CreatedBy.System || createdBy === 0) {
    return t('competences.CREATED_BY_SYSTEM');
  } else if (createdBy === CreatedBy.Recruiter || createdBy === 2) {
    return t('competences.CREATED_BY_RECRUITER');
  } else if (createdBy === CreatedBy.RecruiterFromGitHub || createdBy === 3) {
    return t('competences.CREATED_FROM_GITHUB_BY_RECRUITER');
  } else return t('competences.UNKNOWN_CREATOR');
};

export const createdByIcon = (id, createdBy, t) => {
  return (
    <>
      <span id={`iconCreatedBy-${id}`} className={getCreatedByColor(createdBy)}>
        {getCreatedByLetter(createdBy)}
      </span>
      <UncontrolledTooltip delay={{ show: 50, hide: 50 }} target={`iconCreatedBy-${id}`}>
        {getCreatedByMessage(createdBy, t)}
      </UncontrolledTooltip>
    </>
  );
};
